import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ApplicationSubType, Inspection } from '../../shared/models/index';
import { ConnectionCheck } from '../../utils/connection-check';

@Component({
    selector: 'children-inspection-list-table',
    templateUrl: './children-list.component.html',
    standalone: false
})
export class ChildrenInspectionListComponent {
  @Input() public inspections: Inspection[];
  @Output() public toggleSelectInspection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleReport: EventEmitter<Inspection> = new EventEmitter();
  applicationSubType = ApplicationSubType;

  public selectInspection(inspection: Inspection) {
    if (inspection.lastSyncDate || this.isConnection) {
      this.toggleSelectInspection.emit(inspection);
    }
  }

  public get isConnection() {
    return ConnectionCheck.isConnection;
  }

  openReport(inspection: Inspection, event: Event) {
    event.stopPropagation();
    this.toggleReport.emit(inspection);
  }
}
